import { render, staticRenderFns } from "./TDSCertificate.vue?vue&type=template&id=e629017e"
import script from "./TDSCertificate.vue?vue&type=script&lang=js"
export * from "./TDSCertificate.vue?vue&type=script&lang=js"
import style0 from "./TDSCertificate.vue?vue&type=style&index=0&id=e629017e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports